import * as React from "react";
const SvgEcologyLeaf = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	id: "ecology-leaf_icon",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M23.737 3.161a1.007 1.007 0 0 0-1.56-.665 13.43 13.43 0 0 1-7.661 1.949c-6.179 0-8.758 2.519-8.807 2.577a8.056 8.056 0 0 0-2.673 9.543.5.5 0 0 1-.1.534L.268 19.988a1.007 1.007 0 0 0 1.367 1.471C3.351 19.9 6.15 15.2 14.019 11.911a1.007 1.007 0 0 1 .777 1.858 26.3 26.3 0 0 0-8.431 5.541l-.009.01-.232.251a.5.5 0 0 0 .1.769 8 8 0 0 0 4.262 1.223 12.2 12.2 0 0 0 5.784-1.573c8.769-4.824 7.93-14.101 7.467-16.829" }));
export { SvgEcologyLeaf as ReactComponent };
